export default "__VITE_ASSET__BnVIFcMc__"